import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getBaseUrl } from '../../utils/general/getBaseUrl';
import { SUPPLIER } from '../../utils/constants/supplier.constant';

export const supplierApi = createApi({
    reducerPath: 'supplerApi',
    tagTypes: ['Supplier'],
    baseQuery: fetchBaseQuery({
        baseUrl: getBaseUrl(),
    }),
    endpoints: (builder) => ({
        getAllSuppliers: builder.query<
            [],
            {
                page?: number;
                limit?: number;
               
            }
        >({
            query: ({
                page = 1,
                limit = 10,
                
            }) => {
                const queryParams = {
                    url: SUPPLIER.GET_ALL,
                    params: { page, limit },
                };

                // if (customer_first_name) {
                //     //@ts-ignore
                //     queryParams.params.customer_first_name =
                //         customer_first_name;
                // }
                // if (customer_type_id) {
                //     //@ts-ignore
                //     queryParams.params.customer_type_id = customer_type_id;
                // }
                // if (customer_category_id) {
                //     //@ts-ignore
                //     queryParams.params.customer_category_id =
                //         customer_category_id;
                // }

                return queryParams;
            },
        }),
        createSupplier: builder.mutation({
            query: (body) => ({
                url: SUPPLIER.CREATE,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Supplier'],
        }),

        updateSupplier: builder.mutation({
            query: ({ id, body }) => ({
                url: `${SUPPLIER.UPDATE}${id}`,
                method: 'PATCH',
                body,
            }),
            invalidatesTags: ['Supplier'],
        }),
        
        deleteSupplier: builder.mutation({
            query: (id) => ({
                url: `${SUPPLIER.DELETE}${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Supplier'],
        }),
    }),
    keepUnusedDataFor:0
});

export const {
    useGetAllSuppliersQuery,
    useCreateSupplierMutation,
    useUpdateSupplierMutation,
    useDeleteSupplierMutation,
} = supplierApi;
